// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"825":"5336799c","927":"0f56930d","3066":"749d9223","4174":"a7d94862","4183":"d93cd5dc","4292":"5336799c","4322":"42d60a55","8972":"d93cd5dc"}[chunkId] + ".chunk.css";
};